import { withTheme, SvyBadge as Badge } from '@innovorder/savory';

export const SvyBadge = withTheme(Badge);
